import { isBefore, isAfter } from 'date-fns';

import { TypeGuardError } from 'src/core/utils/switchGuard';

import { isActivePeriod, isFuturePeriod, isPastPeriod } from './dateTime';
import { type FilterSettings } from '../models/budgetFilters';
import { type PeriodInterval } from '../models/periodInterval';

export const isPeriodMatchingStatusFilter = (
  period: PeriodInterval,
  filterStatus: FilterSettings['status'],
  { referenceDate = new Date() } = {},
) => {
  switch (filterStatus) {
    case 'active':
      return isActivePeriod(period, { referenceDate });
    case 'future':
      return isFuturePeriod(period, { referenceDate });
    case 'closed':
      return isPastPeriod(period, { referenceDate });
    case undefined:
      return true;
    default:
      throw new TypeGuardError(filterStatus, 'Unknown budget status filter');
  }
};

export const isPeriodMatchingDateFilter = (
  period: PeriodInterval,
  { start, end }: FilterSettings['period'],
) => {
  if (start && isBefore(period.end, start)) {
    return false;
  }
  return !(end && isAfter(period.start, end));
};

export const doesPeriodPassFilters = (
  period: PeriodInterval,
  filters: FilterSettings,
  { referenceDate = new Date() } = {},
) => {
  if (
    !isPeriodMatchingStatusFilter(period, filters.status, { referenceDate })
  ) {
    return false;
  }
  return isPeriodMatchingDateFilter(period, filters.period);
};
